/**
 * Số liên hệ "Mới" cho huy hiệu menu (hợp đồng A0 liên hệ mục 5): GET
 * /platform/lien-he/so-moi khi khung trang dựng, khi đổi trang và khi màn Liên hệ báo
 * vừa cập nhật một dòng. Lỗi (mạng, chưa có API) → 0, không làm phiền người dùng.
 */
import { useEffect, useState } from 'react';
import { lienHeApi } from '../api/lien-he-api';

const SU_KIEN = 'htttn:lien-he-doi';

/** Màn Liên hệ gọi sau khi đổi trạng thái để menu cập nhật số "Mới". */
export function baoLienHeDaDoi(): void {
  window.dispatchEvent(new Event(SU_KIEN));
}

export type ApiSoLienHeMoi = Pick<typeof lienHeApi, 'soMoi'>;

export function dungSoLienHeMoi(bat: boolean, api: ApiSoLienHeMoi, moc: unknown): number {
  const [so, datSo] = useState(0);
  const [lan, datLan] = useState(0);

  useEffect(() => {
    const nghe = (): void => datLan((x) => x + 1);
    window.addEventListener(SU_KIEN, nghe);
    return () => window.removeEventListener(SU_KIEN, nghe);
  }, []);

  useEffect(() => {
    if (!bat) {
      datSo(0);
      return undefined;
    }
    const boHuy = new AbortController();
    api
      .soMoi(boHuy.signal)
      .then((n) => {
        if (!boHuy.signal.aborted) datSo(typeof n === 'number' && n > 0 ? n : 0);
      })
      .catch(() => {
        if (!boHuy.signal.aborted) datSo(0);
      });
    return () => boHuy.abort();
  }, [bat, api, moc, lan]);

  return so;
}
